import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { FilterOption, RangeSliderOption } from '@immosky/types';
import { connectedPositionsBottomLeftPriority } from '../../../utils/dropdown-conntected-positions';

@Component({
  selector: 'lib-range-slider-dropdown',
  templateUrl: './range-slider-dropdown.component.html',
  styleUrls: ['./range-slider-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangeSliderDropdownComponent {
  isDropdownOpen = false;

  @Input()
  options!: RangeSliderOption[];

  @Input()
  currentOption!: RangeSliderOption;

  @Input()
  defaultOption!: RangeSliderOption;

  @Input()
  overlayPositions: ConnectedPosition[] = connectedPositionsBottomLeftPriority;

  @Output()
  update = new EventEmitter<RangeSliderOption>();

  @ContentChild(TemplateRef)
  unitTemplate!: TemplateRef<unknown>;

  constructor(private cdRef: ChangeDetectorRef) {}

  toggleDropdown() {
    if (this.isDropdownOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isDropdownOpen = true;
    this.cdRef.markForCheck();
  }

  close() {
    window.requestAnimationFrame(() => {
      this.isDropdownOpen = false;
      this.cdRef.markForCheck();
    });
  }

  select(option: FilterOption) {
    this.update.emit(option as RangeSliderOption);
    this.close();
  }
}
